export const tableNames = {
  USERS: 'users',
  DEMANDS: 'demands',
  INTEGRATIONS: 'integrations',
  TRACKED_PUBLISHERS: 'trackedPublishers',
  TRACKED_LINES: 'trackedLines',
  ALL_LINES: 'allLines',
}

export const notification = [
  { key: 'ALL', value: 'ALL' },
];
